import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BottomSheetList, LazyImage, Spinner, LikeCardShimmer } from 'shared-ui/components'
import { SUPER_APP_CONFIG } from 'shared-ui/utils/constants'
import { profileImageSmall } from 'shared-ui/assets'
import { useTheme } from 'styled-components'
import { getGuestUser } from 'shared-ui/utils/localStorage'

function LikeListBottomDrawer({
  showLikesSheet,
  setShowLikesSheet,
  setShowGuestModal,
  likesList,
  likesLoading,
  likesActionUserId,
  handleLikesSheetFollowToggle,
  likesFollowState
}) {
  const theme = useTheme()
  const user = useSelector((state) => state.auth.user)
  const navigate = useNavigate()

  const renderLikeItem = (like) => {
    const targetUserId = like?.user_id || like?.id
    const isSelf = targetUserId === user?.user_id
    const isLoadingAction = likesActionUserId === targetUserId
    const isFollowing =
      likesFollowState[targetUserId] ?? like?.is_following ?? false
    return (

      <div
        key={like?.id || targetUserId}
        className="flex items-center justify-between py-3 gap-2 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation()
          setShowLikesSheet(false)
          navigate(`/creator/${targetUserId}`, { state: like })
        }}
      >
        <div className="flex flex-1 items-center space-x-3 overflow-hidden">
          <LazyImage
            src={like?.profile_picture || profileImageSmall}
            alt={like?.username}
            backUpImage={profileImageSmall}
            className="w-10 h-10 rounded-full object-cover shrink-0"
          />
          <span
            className="text-left font-medium text-base overflow-hidden text-ellipsis whitespace-nowrap"
            style={{ color: theme.app.text }}
          >
            {like?.username}
          </span>
        </div>
        <button
          className="px-6 py-1 border border-cyan-400 rounded-full text-cyan-400 font-semibold text-base bg-transparent hover:bg-cyan-900/20 transition disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isSelf || isLoadingAction}
          onClick={(e) => {
            e.stopPropagation()
            if (getGuestUser() == 'true') {
              setShowGuestModal(true)
              return
            }
            if (isSelf) return
            handleLikesSheetFollowToggle(like)
          }}
        >
          {isFollowing
            ? `${SUPER_APP_CONFIG.DISCOVER_INDEX_FOLLOWING}`
            : `${SUPER_APP_CONFIG.DISCOVER_INDEX_FOLLOW}`}
        </button>
      </div>

    )
  }
  return (
    <BottomSheetList
      open={showLikesSheet}
      onClose={() => setShowLikesSheet(false)}
      title={SUPER_APP_CONFIG.DISCOVER_INDEX_LIKES_TITLE}
      type="Likes"
      data={likesList?.likes || []}
      likeCount={likesList?.likes_count || 0}
      viewCount={likesList?.views_count || 0}
      searchPlaceholder={
        SUPER_APP_CONFIG.CREATE_CONTENT_DETAILS_SEARCH_LIKES_PLACEHOLDER
      }
      initialLoading={likesLoading}
      renderItem={renderLikeItem}
      emptyState={
        <div className="text-center text-gray-400 py-8">
          {SUPER_APP_CONFIG.DISCOVER_INDEX_NO_LIKES_YET}
        </div>
      }
    />
  )
}

export default LikeListBottomDrawer
